import React from 'react';
import { Button } from 'antd';

import useItemOwnTag from '../../hooks/useItemOwnTag';
import { TAG_ICON } from '../icons';

/**
 * The read view's door to USE AS A TAG / STOP USING AS A TAG (docs/plans/
 * tags.md §5.2; build step T4d), under the item's Tags row. The same hook as
 * the item's ⋯ (hooks/useItemOwnTag.js), so the two never disagree: nothing
 * at all unless the person manages the item's collection and its card is in
 * Chosen items mode there. On an archived collection a manager sees, for an
 * item that is a tag, that it is one and why that cannot change.
 */
export default function ItemOwnTagRow({ item, card, title, cardType, collection, onItemUpdated }) {
	const { action, used, note, modal, busy } = useItemOwnTag({ item, card, title, cardType, collection, onItemUpdated });
	if (!action && note) {
		return (
			<div className="item-own-tag" data-testid="item-own-tag">
				<span className="item-own-tag__text">{note}</span>
				{modal}
			</div>
		);
	}
	if (!action) return modal;
	return (
		<div className="item-own-tag" data-testid="item-own-tag">
			<span className="item-own-tag__text">
				{used ? 'This item is used as a tag.' : 'Put this item on other items as a tag.'}
			</span>
			<Button size="small" icon={<TAG_ICON aria-hidden="true" />} loading={busy} onClick={action.onClick}>
				{action.label}
			</Button>
			{modal}
		</div>
	);
}
